import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import axios from 'axios';
import form from '../img/Form/form.png';

const Form = () => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [focus, setFocus] = useState({
    name: false,
    email: false,
    phone: false,
    message: false
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.name.trim()) newErrors.name = 'form.9';
    if (!formData.email.trim()) newErrors.email = 'form.10';
    else if (!emailRegex.test(formData.email)) newErrors.email = 'form.11';
    if (!formData.phone.trim()) newErrors.phone = 'form.12';
    else if (formData.phone.replace(/\D/g, '').length < 10) newErrors.phone = 'form.13';
    if (!formData.message.trim()) newErrors.message = 'form.14';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      const response = await axios.post('https://civbt.xyz/api/bot/iLEnCJGahO', formData);
      if (response.status === 200) {
        alert('Сообщение отправлено!');
        setFormData({ name: '', email: '', phone: '', message: '' });
        setErrors({});
      } else {
        alert('Ошибка при отправке сообщения.');
      }
    } catch (error) {
      console.error('Ошибка:', error);
      alert('Ошибка подключения к серверу.');
    }
  };

  return (
    <div className='max-w-[850px] mx-[20px] md:mx-auto pt-[100px]'>
      <div className='flex flex-col xl:flex-row justify-between py-[50px] xl:py-[180px]'>
        <Link to="/"><svg className='xl:hidden absolute right-[20px] top-[80px]' xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M1.53384 17.4107L0.589844 16.4667L8.05651 9.00002L0.589844 1.53336L1.53384 0.589355L9.00051 8.05602L16.4672 0.589355L17.4112 1.53336L9.94451 9.00002L17.4112 16.4667L16.4672 17.4107L9.00051 9.94402L1.53384 17.4107Z" fill="white"/>
        </svg></Link>
        <div className='relative'>
          <img src={form} alt="" className='hidden xl:block'/>
          <div className='xl:absolute top-[80px]'>
            <p className='text-[28px] xl:text-[45px] open-sans text-[#F26522] leading-[1]'>{t('form.1')}</p>
            <p className='text-[14px] text-[#F6F6F6] open-sans font-[300] xl:max-w-[345px] xl:mx-[25px] mt-[15px] leading-[1.1]'>{t('form.2')}</p>
          </div>
          <Link to="/" className='hidden xl:block'>
            <div className='flex items-center gap-[5px] border-b w-[200px] pb-[8px] border-[#F26522] mt-[40px] group cursor-pointer'>
              <svg className='group-hover:-translate-x-[5px] transition-all' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M21 12L3 12" stroke="#F6F6F6" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6 15L3 12L6 9" stroke="#F6F6F6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <p className='text-[#F6F6F6] open-sans text-[14px] font-[300] group-hover:font-[400] transition-all'>{t('form.3')}</p>
            </div>
          </Link>
        </div>

        <div className='flex flex-col mt-[20px] xl:mt-0'>
          <div className='flex flex-col gap-[14.5px]'>
            {['name', 'email', 'phone', 'message'].map((field, index) => {
              const isActive = focus[field] || formData[field];

              return (
                <div key={field}>
                  <div className={`relative xl:w-[393px] ${errors[field] ? 'border border-red-500' : 'border border-[#FFFFFF80]'} rounded px-[8px] pt-[18px] pb-[6px]`}>
                    <label
                      htmlFor={field}
                      className={`
                        absolute transition-all duration-200 ease-in-out
                        ${isActive ? 'top-[4px] text-[10px] text-[#FFFFFF66] left-[8px] ' : 'left-[22px]  top-[17px] text-[14px] text-[#FFFFFF66]'}
                      `}
                    >
                      {t(`form.${4 + index}`)}
                    </label>
                    <input
                      id={field}
                      name={field}
                      type="text"
                      value={formData[field]}
                      onChange={handleChange}
                      onFocus={() => setFocus(prev => ({ ...prev, [field]: true }))}
                      onBlur={() => setFocus(prev => ({ ...prev, [field]: false }))}
                      className={`focus:outline-none bg-[#1D1D1D] text-[#FFFFFFB2] text-[14px] px-[22px] pt-[6px] w-full`}
                      placeholder=""
                    />
                  </div>
                  {errors[field] && (
                    <p className="text-red-500 text-[12px] px-[8px] pt-[2px]">{t(errors[field])}</p>
                  )}
                </div>
              );
            })}
          </div>

          <div className='xl:ml-auto flex items-center justify-between'>
            <Link to="/" className='xl:hidden block'>
              <div className='flex items-center gap-[5px] border-b w-[122px] pb-[8px] border-[#F26522] mt-[40px] group cursor-pointer'>
                <svg className='group-hover:-translate-x-[5px] transition-all' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M21 12L3 12" stroke="#F6F6F6" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M6 15L3 12L6 9" stroke="#F6F6F6" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <p className='text-[#F6F6F6] open-sans text-[14px] font-[300] group-hover:font-[400] transition-all'>{t('form.3')}</p>
              </div>
            </Link>

            <div onClick={handleSubmit} className="contactus hover:scale-[1.1] transition-all mt-[30px] cursor-pointer">
              <p className="montserrat font-[600] text-[14px] xl:text-[16px]">{t('form.8')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
